import { AxiosResponse } from "axios";
import { Endpoint } from "./util/contants";
import {
  apiGetRequest,
  apiPostRequest,
  createPayload,
} from "./util/apiUtils";
import { AuthResponse, UserResponse } from "./responsePayload/AuthResponse";


export const Login = async (
  username: string,
  password: string
): Promise<AuthResponse | null> => {
  const basePayload = {
    username: username,
    password: password,
  };

  const payload = createPayload(basePayload);

  return await apiPostRequest<AuthResponse>(Endpoint.Login, payload);
};

export const GetUser = async (): Promise<UserResponse | undefined> => {
  return await apiGetRequest<UserResponse>(Endpoint.User);
};

export const Logout = async (
  refreshToken: string
): Promise<AxiosResponse | null> => {
  const basePayload = {
    refresh: refreshToken,
  };

  const payload = createPayload(basePayload);
  return await apiPostRequest(Endpoint.Logout, payload);
};


